import { SearchTerm } from './SearchTerm';

const AuditSubTypeSearch: SearchTerm [] = [
    {
        heading: 'Name',
        accessor: 'name',
        searchOnName: 'nameOriginal',
        translationKey: "name"
    }
];

export default AuditSubTypeSearch;

